import { createSlice } from '@reduxjs/toolkit';
import { resetALL } from 'Redux/actions';

const chatData = [
  {
    id: 'ai',
    iconUrl: '/assets/icons/chat/ai.svg',
    lastMessage: {
      message: null,
    },
    type: 'ai',
  },
  {
    id: 'support',
    iconUrl: '/assets/icons/chat/chat-support-icon.png',
    lastMessage: {
      message: null,
    },
    type: 'support',
  },
];

const initialState = {
  chats: chatData,
  openModal: false,
  activeChatType: null,
  selectedChat: null,
  loading: false,
  error: null,
};

const supportChatListRedux = createSlice({
  name: 'supportChatListRedux',
  initialState,
  reducers: {
    openChat: (state, action) => {
      const { chatId } = action.payload;
      state.activeChatType = chatId;
      state.openModal = true;
      state.selectedChat = state.chats.find((chat) => chat.id === chatId) || null;
    },
    closeChat: (state) => {
      state.activeChatType = null;
      state.openModal = false;
      state.selectedChat = null;
    },
    updateLastMessage: (state, action) => {
      const { chatId, message } = action.payload;
      const chat = state.chats.find((item) => item.id === chatId);
      if (chat) {
        chat.lastMessage.message = message;
      }
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => initialState);
  },
});

export const {
  openChat,
  closeChat,
  updateLastMessage,
  setLoading,
  setError,
} = supportChatListRedux.actions;

export default supportChatListRedux.reducer;
